import ivclass from '@invideoio/web-shared/Modules/IVClass';
import Link from 'next/link';

import { BlogAuthorType } from 'src/types';
import { getFormattedDate } from '@utils/common.utils';
import ImageComponent from '@components/common/ImageComponent/ImageComponent';
import { PlatformType } from '@invideoio/web-shared/constants/common';
import { BrowserType } from '@constants/common';
import { getImageSize } from '@utils/getImageSize';
import { useEffect, useState } from 'react';

interface AuthorDetailsPropType {
  author: BlogAuthorType | undefined | null;
  publishedAt: string;
  platform: PlatformType;
  browser: BrowserType;
}

const AUTHOR_IMAGEKIT_MAP = {
  [PlatformType.Desktop]: { height: 60 },
  [PlatformType.Tablet]: { height: 60 },
  [PlatformType.Mobile]: { height: 45 },
  default: { height: 60 },
};

const AuthorDetails = ({
  author,
  publishedAt,
  browser,
  platform,
}: AuthorDetailsPropType) => {
  const [publishAtDate, setPublishAtDate] = useState('');
  useEffect(() => {
    if (typeof publishedAt === 'string') {
      setPublishAtDate(getFormattedDate(new Date(publishedAt)));
    }
  }, [publishedAt]);

  return (
    <Link href={`/blog/author/${author?.slug}/`} locale={false}>
      <a
        className={ivclass(
          'iv-flex iv-items-center',
          'iv-mx-20 lg:iv-mx-[13px] md:iv-mx-[15px]',
          'iv-py-10',
          'iv-gap-20',
        )}
      >
        <ImageComponent
          elementype="imagekit"
          loading="lazy"
          src={author?.avatar?.url || ''}
          sizeTransformation={getImageSize(platform, AUTHOR_IMAGEKIT_MAP)}
          alt="author"
          fetchpriority="high"
          className={ivclass(
            'iv-h-[60px] sm:iv-h-[45px]',
            'iv-w-[60px] sm:iv-w-[45px]',
            'iv-rounded-[100%]',
            'iv-cursor-pointer',
            'iv-object-cover',
          )}
        />
        <div className={ivclass('iv-pt-5 sm:iv-pt-[0]')}>
          <div
            className={ivclass(
              'iv-text-body-3xl iv-font-medium',
              'sm:iv-text-body-l ',
              'iv-cursor-pointer',
            )}
          >
            {author?.name ?? ''}
          </div>
          <div
            className={ivclass(
              'iv-text-body-3xl iv-font-medium',
              'sm:iv-text-body-m',
              'iv-text-black-50',
              'iv-cursor-default',
            )}
          >
            {publishAtDate}
          </div>
        </div>
      </a>
    </Link>
  );
};

export default AuthorDetails;
